import MaterialIcon from '@components/common/MaterialIcon';
import type React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  url: string;
};

export const ConversationReviewSourceUrlSection: React.FC<Props> = ({
  url,
}) => {
  const { t } = useTranslation();

  return (
    <div className='conversation-review-modal__section'>
      <div className='conversation-review-modal__section-label'>
        <MaterialIcon
          type='outlined'
          icon='link'
          classes={['conversation-review-modal__section-label-icon']}
        />
        <span className='conversation-review-modal__section-label-text'>
          {t('train-ai.conversation-review.url-label')}
        </span>
      </div>
      <div className='conversation-review-modal__url-box'>
        <a
          href={url}
          target='_blank'
          rel='noreferrer'
          className='conversation-review-modal__url-link'>
          {url}
        </a>
      </div>
    </div>
  );
};
